module.exports = __webpack_public_path__ + "img/PlaySquare.0b33f657.svg";